import Vue from 'vue'

const env = {
  appName: process.env.VUE_APP_NAME || 'Road Ramble',
  apiUrl: process.env.VUE_APP_API_URL || 'https://baseplate-api.test/api/v1',
  spotifyClientId: process.env.VUE_APP_SPOTIFY_CLIENT_ID || '',
  spotifyClientSecretKey: process.env.VUE_APP_SPOTIFY_CLIENT_SECRET_KEY || '',
  firebaseAppId: process.env.VUE_APP_FIREBASE_APP_ID || '',
  firebaseProjectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || '',
  firebaseApiKey: process.env.VUE_APP_FIREBASE_API_KEY || '',
  firebaseMessagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID || ''
}

Vue.prototype.$env = env

export default env
